import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbModule,} from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { ExamplesModule } from './examples/examples.module';

import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { CommonModule } from '@angular/common';
import { JwBootstrapSwitchNg2Module } from 'jw-bootstrap-switch-ng2';
import { NouisliderModule } from 'ng2-nouislider';
import { ChiSiamoComponent } from './pages/chi-siamo/chi-siamo.component';
import { AgGridModule } from 'ag-grid-angular';
import { TablesAgGridComponent } from './pages/tables-ag-grid/tables-ag-grid.component';
import { NewModalService } from './generic/new-modal/new-modal.service';
import { NewConfirmModalService } from './generic/new-confirm-modal/new-confirm-modal.service';
import { TablesAgGridModule } from './pages/tables-ag-grid/tables-ag-grid.module';
import { TablesAgGridService } from './pages/tables-ag-grid/tables-ag-grid.service';
import { MappaAllertaModule } from './components/mappa-allerta/mappa-allerta.module';
import { LandingPageModule } from './pages/landing-page/landing-page.module';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { WidgetPrevisioniModule } from './components/widget-previsioni/widget-previsioni.module';
import { WidgetTabellaModule } from './components/widget-tabella/widget-tabella.module';
import { MeteoComponent } from './pages/meteo/meteo.component';
import { TempoRealeComponent } from './pages/tempo-reale/tempo-reale.component';
import { LivAllertaLegendaModule } from './components/livelli-allerta-legenda/livAllertaLegenda.module';
import { GuidaAllertaModule } from './components/guida-allerta/guida-allerta.module';
import { PrevisioniModule } from './components/previsioni/previsioni.module';
import { NbButtonModule, NbCardModule, NbDatepickerModule, NbInputModule, NbLayoutModule, NbOverlayContainer, NbTabsetModule, NbThemeModule } from '@nebular/theme';
import { TaAllertaDownloadModule } from './components/ta-allerta-download/ta-allerta-download.module';
import { TaComunicazioniModule } from './components/ta-comunicazioni/ta-comunicazioni.module';
import { BollettiniMeteoModule } from './components/bollettini-meteo/bollettini-meteo.module';
import { ArchivioAllertaMassimaModule } from './components/archivio-allerta-massima/archivio-allerta-massima.module';
import { NewsComponent } from './pages/news/news.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { SensorChartComponent } from './components/sensor-chart/sensor-chart.component';   
import { JwtInterceptor } from './generic/jwt.interceptor';
import { DatiComponent } from './pages/dati/dati.component';
import { CustomDatepickerI18n } from './shared/datepicker-it.service';
import { CustomDateParserFormatter } from './shared/custom-date-parser-formatter';
import { DocumentiComponent } from './pages/documenti/documenti.component';
import { RapportiModule } from "./pages/documenti/rapporti/rapporti.module";
import { CusSatComponent } from './components/cus-sat/cus-sat.component';
import { DisclaimerComponent } from './pages/disclaimer/disclaimer.component';
import { MonografieModule } from "./pages/documenti/monografie/monografie.module";
import { NormativaModule } from "./pages/documenti/normativa/normativa.module";
import { ElaborazioniClimaticheModule } from "./pages/documenti/elaborazioni-climatiche/elaborazioni-climatiche.module";
import { AnnaliModule } from './pages/documenti/annali/annali.module';
import { IctRadioComponent } from './pages/ict-radio/ict-radio.component';
import { IctRadioModule } from './pages/ict-radio/ict-radio.module';
import { RicercaElementiComponent } from './pages/ricerca-elementi/ricerca-elementi.component';
import { RicercaElementiModule } from './pages/ricerca-elementi/ricerca-elementi.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { AltroModule } from './pages/documenti/altro/altro.module';



@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        FooterComponent,
        LandingPageComponent,
        ChiSiamoComponent,
        TablesAgGridComponent,
        MeteoComponent,
        TempoRealeComponent,
        NewsComponent,
        ErrorPageComponent,
        SensorChartComponent,
        DatiComponent,
        DocumentiComponent,
        CusSatComponent,
        DisclaimerComponent,
        IctRadioComponent,
        RicercaElementiComponent
    ],
    imports: [
    AgGridModule,
    BrowserModule,
    HttpClientModule,
    ComponentsModule,
    NouisliderModule,
    JwBootstrapSwitchNg2Module,
    CommonModule,
    BrowserAnimationsModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    RouterModule,
    AppRoutingModule,
    ExamplesModule,
    AgGridModule,
    TablesAgGridModule,
    MappaAllertaModule,
    LandingPageModule,
    WidgetPrevisioniModule,
    WidgetTabellaModule,
    LivAllertaLegendaModule,
    GuidaAllertaModule,
    PrevisioniModule,
    NbThemeModule.forRoot({ name: 'default' }),
    NbLayoutModule,
    TaAllertaDownloadModule,
    TaComunicazioniModule,
    BollettiniMeteoModule,
    ArchivioAllertaMassimaModule,
    NgxEchartsModule.forRoot({ echarts }),
    NbDatepickerModule.forRoot(),
    NbInputModule,
    NbTabsetModule,
    NbCardModule,
    RapportiModule,
    MonografieModule,
    NormativaModule,
    AltroModule,
    ElaborazioniClimaticheModule,
    AnnaliModule,
    IctRadioModule,
    RicercaElementiModule,
],
    providers: [
        NewModalService,
        NewConfirmModalService,
        TablesAgGridService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true, // Più interceptor
        },
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        {provide: NbOverlayContainer, useClass: NbOverlayContainer},
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
